import { getCore } from '../../../client/core/getCore';
import type { DynamicClient } from '../../../client/types';
import { getBuffer } from '../../../utils/getBuffer';
import { p256Keygen } from '../../../utils/p256Keygen';
import type { SessionKeys } from '../sessionKeys.types';

export const generateSessionKeys = async (
  client: DynamicClient
): Promise<SessionKeys> => {
  const {
    private: privateKey,
    public: publicKey,
    privateJwk: privateKeyJwk,
  } = await p256Keygen();

  const core = getCore(client);

  // stringify and encode the session keys to store in storage
  const stringifiedSessionKeys = JSON.stringify({
    privateKey,
    privateKeyJwk,
    publicKey,
    registered: false,
  });

  const encodedSessionKeys = getBuffer()
    .from(stringifiedSessionKeys)
    .toString('base64');

  core.state.set({
    sessionKeys: encodedSessionKeys,
  });

  return { privateKey, privateKeyJwk, publicKey };
};
